import React, { useEffect, useState } from 'react';
import { getIn18Text } from 'api';
import { Popover, Tooltip } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder as api, apis } from 'api';
import { useAppSelector, useActions, MailTemplateActions } from '@web-common/state/createStore';
import WriteContent from '@web-mail-write/WritePage';
import { verifyEmail } from '@web-mail-write/util';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import DeleteConfirm from './delete_confirm';
import Preview from './preview';
import { formatTemplateDetail, formatSaveTemplateReq } from './util';
import { ReactComponent as DeleteIcon } from '@/images/icons/modal_close_temp.svg';
import './addmodal.scss';
const templateApi = api.api.requireLogicalApi(apis.mailTemplateImplApi);
export const WriteContext = React.createContext({});
export const TemplateAddModal = (props) => {
    const { templateCategory = 'LX', maskStyle = {}, operateMail = '', isSetting } = props;
    const showAddTemplatePop = useAppSelector(state => state.mailTemplateReducer.showAddTemplatePop);
    const currentMail = useAppSelector(state => state.mailTemplateReducer.mailTemplateContent);
    const mailTemplateName = useAppSelector(state => state.mailTemplateReducer.mailTemplateName);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const showWriteContact = useAppSelector(state => { var _a; return (_a = state.mailTemplateReducer.mailTemplateContent.status) === null || _a === void 0 ? void 0 : _a.showContact; });
    const isModified = useAppSelector(state => state.mailTemplateReducer.isModified);
    const addTemplatePopSource = useAppSelector(state => state.mailTemplateReducer.showAddTemplatePopSource);
    const isClosePreviewModal = useAppSelector(state => state.mailTemplateReducer.isClosePreviewModal);
    const { changeShowAddTemplatePop, doMailTemplateInit, doClosePreviewModal } = useActions(MailTemplateActions);
    const [showConfirm, setShowConfirm] = useState(false);
    const [btnDisable, setBtnDisable] = useState(true);
    const [saveBtnTxt, setSaveBtnTxt] = useState(getIn18Text('BAOCUNMOBAN'));
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    useEffect(() => {
        if (showAddTemplatePop) {
            if (JSON.stringify(currentMail) === '{}') {
                doMailTemplateInit();
            }
        }
    }, [showAddTemplatePop]);
    useEffect(() => {
        if (templateCategory === 'LX-WAIMAO') {
            if (mailTemplateName && currentMail.entry.title) {
                setBtnDisable(false);
            }
            else {
                setBtnDisable(true);
            }
            return;
        }
        if (mailTemplateName && (isModified || (currentMail && currentMail.receiver && currentMail.receiver.length > 0) || currentMail.entry.title)) {
            setBtnDisable(false);
        }
        else {
            setBtnDisable(true);
        }
    }, [isModified, mailTemplateName, currentMail]);
    useEffect(() => {
        if (isClosePreviewModal) {
            setShowPreviewModal(false);
            doClosePreviewModal(false);
        }
    });
    const doSaveMailTemplate = () => {
        if (btnDisable) {
            return;
        }
        const { receiver } = currentMail;
        const receiverError = receiver === null || receiver === void 0 ? void 0 : receiver.filter(item => { var _a, _b; return !verifyEmail(((_b = (_a = item === null || item === void 0 ? void 0 : item.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) === null || _b === void 0 ? void 0 : _b.trim()) || ''); });
        if (receiverError === null || receiverError === void 0 ? void 0 : receiverError.length) {
            const msg = receiverError.length === 1 ? getIn18Text('YOUXIANGDEZHICUO') : getIn18Text('CUNZAICUOWUDE');
            message.error({
                content: msg,
            });
            return;
        }
        setSaveBtnTxt(getIn18Text('BAOCUNZHONG..'));
        const params = formatSaveTemplateReq(currentMail, mailTemplateName, templateCategory);
        const _account = isSetting ? operateMail : curAccount ? curAccount.mailEmail : '';
        templateApi.doSaveMailTemplate(params, _account).then(res => {
            if (res.success) {
                message.success({
                    content: addTemplatePopSource === 'list' ? getIn18Text('BAOCUNCHENGGONG') : getIn18Text('BAOCUNCHENGGONG\uFF0C'),
                });
                changeShowAddTemplatePop({ isShow: false });
                doMailTemplateInit();
            }
            else {
                message.error({
                    content: res.message || getIn18Text('BAOCUNCUOWU\uFF0C'),
                });
            }
            setSaveBtnTxt(getIn18Text('BAOCUNMOBAN'));
        });
    };
    const handleDeleteConfirm = () => {
        setShowConfirm(false);
        changeShowAddTemplatePop({ isShow: false });
        doMailTemplateInit();
    };
    const tempDiff = () => {
        if (isModified) {
            return Promise.resolve(true);
        }
        if (!currentMail.id) {
            if (currentMail.entry.title || mailTemplateName) {
                return Promise.resolve(true);
            }
            return Promise.resolve(false);
        }
        const receiverChange = (originData) => {
            if (currentMail.receiver.length !== originData.to.length + originData.cc.length + originData.bcc.length) {
                return true;
            }
            for (let i = 0; i < currentMail.receiver.length; i++) {
                const onReceiverValue = currentMail.receiver[i].contactItem.contactItemVal;
                const onReceiverType = currentMail.receiver[i].mailMemberType;
                if (originData[onReceiverType].indexOf(onReceiverValue) === -1) {
                    return true;
                }
            }
            return false;
        };
        const _account = isSetting ? operateMail : curAccount ? curAccount.mailEmail : '';
        return templateApi.doGetMailTemplateDetail({ templateId: currentMail.id }, _account).then(async (res) => {
            if (res.success && res.data) {
                if (mailTemplateName !== res.data.templateName || currentMail.entry.title !== res.data.subject || receiverChange(res.data)) {
                    return true;
                }
                return false;
            }
            return true;
        });
    };
    const closeModal = async () => {
        const isChange = await tempDiff();
        if (isChange) {
            setShowConfirm(true);
        }
        else {
            handleDeleteConfirm();
        }
    };
    return (React.createElement(Modal, { closeIcon: React.createElement(DeleteIcon, { className: "dark-invert" }), visible: showAddTemplatePop, maskStyle: maskStyle, footer: null, title: currentMail.id ? getIn18Text('BIANJIGERENMO') : getIn18Text('XINJIANGERENMO'), width: showWriteContact ? '962px' : '742px', className: "mail-template-add-modal", onCancel: closeModal, destroyOnClose: true, maskClosable: false },
        React.createElement("div", { className: "write" },
            React.createElement(WriteContext.Provider, { value: { isMailTemplate: true } },
                React.createElement(WriteContent, { cond: "addTemplate" }))),
        React.createElement("div", { className: "add-footer-btn" },
            React.createElement("button", { type: "button", onClick: closeModal }, getIn18Text('QUXIAO')),
            React.createElement(Popover, { visible: showPreviewModal, onVisibleChange: visible => {
                    setShowPreviewModal(visible);
                }, placement: "topRight", content: btnDisable ? '' : React.createElement(Preview, { defaultTemplateData: formatTemplateDetail(currentMail) }), trigger: "click" },
                React.createElement("button", { type: "button", className: btnDisable ? 'btn-disable' : '' }, getIn18Text('YULAN'))),
            React.createElement(Tooltip, { title: btnDisable ? '请添加模板名称' : '' },
                React.createElement("button", { type: "button", className: btnDisable ? 'btn-disable primary' : 'primary', onClick: doSaveMailTemplate }, saveBtnTxt))),
        React.createElement(DeleteConfirm, { showConfirm: showConfirm, setShowConfirm: setShowConfirm, handleConfirm: handleDeleteConfirm })));
};
